<template>
    <el-dialog v-drag class="cer-box-dialog" width="500px" :append-to-body="appendBody" :visible.sync="cerDialogVisible" :before-close="handleClose">
            <div slot="title">上传</div>
            <el-form
                class="form-item"
                ref="formbox"
                :model="form2"
                :rules="rules"
                :label-width="formLabelWidth"
            >
                <el-form-item :label="itemtitle" prop="certificateNo" class="dialog-item">
                    <el-input
                        v-model="form2.certificateNo"
                        placeholder="请输入证件号"
                        class="input-class"
                        :disabled="!(showtypecode==='3' || showtypecode==='4')"
                    ></el-input>
                </el-form-item>
                <el-form-item label="身份证照（人像面）" prop="uploadIdentityFront" class="upload-item dialog-item" v-if="showtypecode==='1'">
                    <el-input v-model="form2.uploadIdentityFront" placeholder="点击上传附件" class="input-class" readonly></el-input>
                    <upload
                        :uploadDisplayType="uploadDisplayType"
                        :accept="'image/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf'"
                        :flag="flag"
                        class="upload-item-icon"
                        :ocr="'idCardFont'"
                        @uploadSuccess="cerCallback">
                    </upload>
                    <span @click="previewBtn('cer')" class="preview_btn">预览</span>
                </el-form-item>
                <el-form-item label="身份证照（国徽面）" prop="uploadIdentityBehind" class="upload-item dialog-item" v-if="showtypecode==='1'">
                    <el-input v-model="form2.uploadIdentityBehind" placeholder="点击上传附件" class="input-class" readonly></el-input>
                    <upload
                            :uploadDisplayType="uploadDisplayType"
                            :accept="'image/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf'"
                            :flag="flag"
                            :ocr="'idCardBehind'"
                            class="upload-item-icon"
                            @uploadSuccess="cerCallback">
                    </upload>
                    <span @click="previewBtn('cerbehi')" class="preview_btn">预览</span>
                </el-form-item>
                <el-form-item label="上传附件" prop="fileName" class="upload-item dialog-item" v-if="showtypecode==='2' || showtypecode==='3' || showtypecode==='4'">
                    <el-input v-model="form2.fileName" placeholder="点击上传附件" class="input-class" readonly></el-input>
                    <upload
                        :uploadDisplayType="uploadDisplayType"
                        :accept="'image/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf'"
                        :flag="flag"
                        class="upload-item-icon"
                        @uploadSuccess="callback">
                    </upload>
                    <span @click="previewBtn('normal')" class="preview_btn">预览</span>
                </el-form-item>
                <el-form-item :label="dataStart" class="dialog-item" prop="certificateBeginDate">
                    <el-date-picker
                        class="input-date"
                        v-model="form2.certificateBeginDate"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item :label="dataEnd" prop="certificateEndDate" class="dialog-item">
                    <el-date-picker
                        class="input-date"
                        v-model="form2.certificateEndDate"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期"
                        :picker-options="pickerOptions"
                    ></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="save('cert')">确 定</el-button>
            </div>
        </el-dialog>
</template>
<script>
import upload from '../../../../../components/upload/Index';
import { insertUpdateIdCard, uploadFiles } from '../../../../../api/qualification.js';
import { verifyDate } from '../../../../../utils/common.js';

export default {
    components: { upload },
    props: {
        autoUpload: {
            type: Boolean,
            default: true
        },
        appendBody: {
            type: Boolean,
            default() {
                return false;
            }
        },
        cerDialogVisible: {
            type: Boolean,
            default() {
                return false;
            }
        },
        form: {
            type: Object,
            default() {
                return {};
            }
        },
        flag: {
            type: Object,
            default() {
                return {};
            }
        },
        showtype: {
            type: String,
            default() {
                return '0';
            }
        },
        supplierCode: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        // const certificateEndDate = (rule, value, callback) => {
        //     if (!value) {
        //         callback(new Error('请选择终止日期'));
        //     } else if (new Date(value).getTime() < new Date().getTime()) {
        //         callback(new Error('日期要大于当前时间'));
        //     } else {
        //         callback();
        //     }
        // };
        return {
            form2: { fileName: '' },
            uploadDisplayType: 'icon',
            dataStart: '',
            dataEnd: '',
            dialogVisible: false,
            itemtitle: '',
            showtypecode: '0', // 1 身份证, 2 营业执照, 3 道路经营许可证, 4 快递业务经营许可证
            formLabelWidth: '145px',
            rules: {
                certificateNo: [
                    { required: true, message: '请输入证件号' }
                ],
                qualificationName: [
                    { required: true, message: '请输入资质名称', trigger: ['blur', 'change'] }
                ],
                certificateBeginDate: [
                    { required: true, message: '请选择起始日期', trigger: ['blur', 'change'] }
                ],
                certificateEndDate: [
                    { required: true, message: '请选择终止日期', trigger: 'change' }
                ],
                fileName: [
                    { required: true, message: '请上传附件' }
                ],
                uploadIdentityFront: [
                    { required: true, message: '请上传身份证（人像面）' }
                ],
                uploadIdentityBehind: [
                    { required: true, message: '请上传身份证（国徽面）' }
                ]
            },
            pickerOptions: {
                disabledDate: (time) => {
                    const endtime =  (new Date()).getTime()
                    return time.getTime() < endtime;
                }
            },
        };
    },
    mounted() {
        const obj = {
            1: '身份证',
            2: '统一社会信用代码',
            3: '道路经营许可证编号',
            4: '快递经营许可证编号'

        };
        this.dataStart = this.showtype === '4' ? '发证日期' : (this.showtype === '2' ? '营业执照注册起始日期' : '证件起始日期');
        this.dataEnd = this.showtype === '4' ? '有效期至' : (this.showtype === '2' ? '营业执照注册终止日期' : '选择终止日期');
        this.showtypecode = this.showtype;
        this.itemtitle = obj[this.showtype];
        this.form2 = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
        previewBtn(par) {
            this.$emit('previewBtn', par);
        },
        cerCallback(data) {
            if (data.ocr === 'idCardFont') {
                this.$set(this.form2, 'uploadIdentityFront', data.data.ossResult.localFileName);
                // this.$set(this.form2, 'certificateNo', data.data.ocrResult.idNumber);
                this.$set(this.form2, 'uploadIdentityFrontUrl', data.data.ossResult.downUrl);
                this.$set(this.form2, 'uploadIdentityFrontFileId', data.data.ossResult.id);
            } else {
                this.$set(this.form2, 'uploadIdentityBehind', data.data.ossResult.localFileName);
                this.$set(this.form2, 'certificateBeginDate', verifyDate(data.data.ocrResult.idCardStartTime));
                this.$set(this.form2, 'certificateEndDate', verifyDate(data.data.ocrResult.idCardEndTime));
                this.$set(this.form2, 'uploadIdentityBehindUrl', data.data.ossResult.downUrl);
                this.$set(this.form2, 'uploadIdentityBehindFileId', data.data.ossResult.id);
            }
            this.$emit('cerCallback', data);
        },
        callback(data) {
            this.$set(this.form2, 'fileName', data.data.data.localFileName);
            this.$set(this.form2, 'fileUrl', data.data.data.downUrl);
            this.$set(this.form2, 'fileId', data.data.data.id);
            this.$set(this.form2, 'id', data.flag.id);
            this.$emit('callback', data);
        },
        handleClose() {
            this.$emit('handleClose', 'cert');
            this.dialogVisible = false;
            setTimeout(() => {
                if (this.$refs['formbox']) {
                    this.$refs['formbox'].resetFields();
                }
            }, '100');
        },
        save(type) {
            this.form2.supplierCode = this.supplierCode;
            this.$refs['formbox'].validate((valid) => {
                if (valid) {
                    const form = {...this.form2}
                    this.dialogVisible = false;
                    if(this.autoUpload){
                        if (this.showtypecode === '1') {
                            delete this.form2.fileId;
                            delete this.form2.fileName;
                            delete this.form2.fileUrl;
                            delete this.form2.id;
                            delete this.form2.qualificationName;
                                insertUpdateIdCard(this.form2).then(res => {
                                    if (res && +res.code === 0) {
                                        this.$message.success('上传成功');
                                        this.$refs['formbox'].resetFields();
                                        this.$emit('handleClose', 'cert');
                                        this.$emit('search', form);
                                    }
                                });

                        } else {
                            uploadFiles(this.form2).then(res => {
                                if (res && +res.code === 0) {
                                    this.$message.success('上传成功');
                                    this.$refs['formbox'].resetFields();
                                    this.$emit('handleClose', 'cert');
                                    this.$emit('search', form);
                                }
                            });
                         }
                    }else{
                         this.$refs['formbox'].resetFields();
                                this.$emit('handleClose', 'cert');
                                this.$emit('search', form);
                    }

                } else {
                    if (this.showtypecode === '2') {
                        this.$message.warning('请先维护社会信用代码！');
                    }
                    return false;
                }
            });
        }
    }
};
</script>
<style lang="less" scoped>
.cer-box-dialog {
    .btn {
        margin-left: 30px;
        font-size: 12px;
        color: #666;
        cursor: pointer;
    }

    .icon {
        margin-right: 5px;
    }

    margin-top: 10px;

    .idCard {
        top: 4px;
    }

    .upload {
        color: #00bcbf;
        cursor: pointer;
    }

    .input-class {
        width: 260px;

        .el-input__inner {
            width: 260px;
        }
    }

    .form-item .input-date {
        width: 260px !important;
    }

    .upload-item {
        position: relative;

        .upload-item-icon {
            position: absolute;
            top: 2px;
            width: 260px;
            height: 28px;
            font-size: 16px;
            color: #33c9cc;
        }

        .upload-demo {
            width: 100%;
            height: 28px;
        }
    }

    .preview_btn {
        margin-left: 10px;
        text-decoration: underline;
        color: #33c9cc;
        cursor: pointer;
    }

    .form-item {
        .el-form-item {
            margin-bottom: 16px;
        }

        .el-form-item__error {
            padding-top: 0;
        }
    }
}
</style>
